import React, { Component } from 'react';
import { Query } from '@apollo/client/react/components';
import gql from 'graphql-tag';
import Grid from '@components/Grid';
import { Box, Container } from '@components/layout/Grid';
import LoadMoreSection from '@components/LoadMoreSection';
import MetaTags from '@components/MetaTags';
import SectionHeader from '@components/SectionHeader';
import LanguageContext from '@lib/contexts/languageContext';
import { items3 } from '@lib/faker';
import { Trans } from '@lingui/react';
import BlogItemCard from '@organisms/cards/BlogItemCard';
import BlogCardSkeleton from '@skeletons/BlogCardSkeleton';

const GET_POSTS = gql`
  query posts($page: Int, $perPage: Int) {
    posts(page: $page, perPage: $perPage) {
      page
      perPage
      totalCount
      data {
        id
        title
        featuredImage
        body
        slug
      }
    }
  }
`;

const updatePostsQuery = (prev, { fetchMoreResult }) => {
  if (!fetchMoreResult) return prev;
  return Object.assign({}, prev, {
    posts: {
      ...fetchMoreResult.posts,
      data: [...prev.posts.data, ...fetchMoreResult.posts.data],
    },
  });
};

export default class extends Component {
  state = {
    fetchingMore: false,
  };

  render() {
    return (
      <React.Fragment>
        {/* <VideosSubHeader /> */}

        <Container flexDirection={'column'} my="50px" px={[25, 25, 10]}>
          <MetaTags
            title={{
              id: 'opengraph.blog_title',
              defaults: 'Blog Title',
            }}
            description={{
              id: 'opengraph.blog_description',
              defaults: 'Blog Description',
            }}
          />

          <Box mb="20px">
            <SectionHeader title={<Trans id="blog.title" message={'Blog'} />} />
          </Box>

          <Query query={GET_POSTS} variables={{ perPage: 3 }}>
            {({ error, loading, data, fetchMore }) => {
              if (error) return null;
              if (loading) {
                return (
                  <Grid iterableItems={items3} col={3}>
                    {() => <BlogCardSkeleton />}
                  </Grid>
                );
              }
              const { posts } = data;
              return (
                <React.Fragment>
                  <LanguageContext.Consumer>
                    {locale => (
                      <Grid iterableItems={posts.data} col={3}>
                        {item => (
                          <BlogItemCard
                            title={item.title}
                            description={item.body.substring(0, 200)}
                            thumbnailUrl={item.featuredImage}
                            redirectUrl={`/${locale}/blog/${item.slug}`}
                          />
                        )}
                      </Grid>
                    )}
                  </LanguageContext.Consumer>

                  <LoadMoreSection
                    data={posts}
                    loading={this.state.fetchingMore}
                    onLoadMoreClick={() => {
                      this.setState({ fetchingMore: true });
                      fetchMore({
                        variables: {
                          page: posts.page + 1,
                        },
                        updateQuery: updatePostsQuery,
                      }).then(() => {
                        this.setState({ fetchingMore: false });
                      });
                    }}
                  />
                </React.Fragment>
              );
            }}
          </Query>
        </Container>
      </React.Fragment>
    );
  }
}
